import { Component, Input, ViewChild, ElementRef } from '@angular/core';

@Component({
  selector: 'child-info-level',
  templateUrl: './child-info-level.html',
  styleUrls: ['./child-info-level.scss'],
})

export class ChildInfoLevel {

  /**
   * progress graph element
   */
  @ViewChild('graph') graphElement: ElementRef;

  /**
   * 진행 정도
   */
  progress: number = 0;

  /**
   * 진행 정도에 따른 그래프 너비
   */
  width: number = 0;

  /**
   * 그래프 핀 타입
   */
  pinType: number = 0;

  constructor() {}

  @Input('progress') set levelProgress(progress: number) {
    if (this.graphElement) {
      const graphWidth = this.graphElement.nativeElement.clientWidth;
      this.progress = progress;
      this.width = progress / 100 * graphWidth;
      this.pinType = Math.floor(progress / (1 / 3 * 100));
    }
  }
}
